import clsx from 'clsx';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Spinner from '../Spinner/Spinner';

type LoadingProps = {
  hasBackdrop?: boolean;
  isFullScreen?: boolean;
  label?: string;
};

function Loading({
  hasBackdrop = true,
  isFullScreen = true,
  label = '',
}: LoadingProps): JSX.Element {
  const { t } = useTranslation();
  const customLoading = useMemo(() => {
    if (typeof document === 'undefined') return '';
    return getComputedStyle(document.documentElement)
      .getPropertyValue('--loading')
      .replace(/^url\(['"]?|(?:['"]?\))$/g, '')
      .trim();
  }, []);

  const accessibleLabel = label || t('alt:Loading');

  return (
    <div
      aria-busy="true"
      aria-label={accessibleLabel}
      aria-live="polite"
      className={clsx('loading', {
        'loading--contained': !isFullScreen,
        'loading--custom': customLoading,
      })}
      role="status"
    >
      {hasBackdrop && <div aria-hidden="true" className="loading__backdrop" />}

      <div className="loading__wrapper">
        {customLoading ? (
          <img alt="" aria-hidden="true" className="loading__custom-image" src={customLoading} />
        ) : (
          <Spinner />
        )}
      </div>

      {label && <div className="loading__text">{label}</div>}
    </div>
  );
}

export default Loading;
